import { ErrorTransformer, RJSFValidationError } from '@rjsf/utils';

// See docs here https://react-jsonschema-form.readthedocs.io/en/latest/usage/validation/#custom-error-messages
export const transformErrors: ErrorTransformer = (
  errors: RJSFValidationError[],
) => {
  return errors.map(error => {
    if (error.name === 'format' && error.params.format === 'email') {
      error.message = 'Must be a valid email';
    }
    return error;
  });
};
